export const PickupOrderAlertStageEnum = {
  REMIND_READY: 'remind_ready',
  CONFIRM_READY: 'confirm_ready',
  REMIND_PICKED_UP: 'remind_picked_up',
  CONFIRM_PICKED_UP: 'confirm_picked_up',
} as const

export type PickupOrderAlertStageType =
  (typeof PickupOrderAlertStageEnum)[keyof typeof PickupOrderAlertStageEnum]

export type PickupOrderAlertType = {
  orderId: string
  shortId: string
  customerName: string
  type: 'pickup'
  stage: PickupOrderAlertStageType
  raisedAt: string
}
